import React from 'react';
import { ITranslateProps, translate } from '../../../mixins/translate';
import * as htmlHelper from '../../../utils/htmlHelper';
import { EditPanelCell, EditPanelRow, PanelBody, PanelHeading } from '../../elements';
import { CraCondition } from '../CRA/CraCondition';
import { ISurvey } from '../Interfaces/ISurvey';

interface IRiskAssessmentProps extends ITranslateProps {
    surveyDetails: ISurvey;
}

class RiskAssessment extends React.Component<IRiskAssessmentProps, Record<string, unknown>> {
    constructor(props: IRiskAssessmentProps) {
        super(props);
        this.state = {};
    }

    public override render() {
        return (
            <div id="RiskAssessment" className="panel">
                <PanelHeading text={this.props.t('cra.cra')} icon="fa fa-cog" />
                <PanelBody whiteBackground={true}>
                    <EditPanelRow>
                        <EditPanelCell rowCount={2}>
                            {' '}
                            <CraCondition conditionScore={this.props.surveyDetails.craInitialHistoryCondition} />
                        </EditPanelCell>
                        <EditPanelCell rowCount={10}>
                            <strong>{this.props.t('survey.craInitialHistoryCondition')}</strong>
                            <p>{htmlHelper.newLineToBreak(this.props.surveyDetails.craInitialHistoryRemarks)} </p>
                        </EditPanelCell>
                    </EditPanelRow>
                    <EditPanelRow>
                        <EditPanelCell rowCount={2}>
                            {' '}
                            <CraCondition conditionScore={this.props.surveyDetails.craInspectionCondition} />
                        </EditPanelCell>
                        <EditPanelCell rowCount={10}>
                            <strong>{this.props.t('survey.craInspectionCondition')}</strong>
                            <p> {htmlHelper.newLineToBreak(this.props.surveyDetails.craInspectionRemarks)} </p>
                        </EditPanelCell>
                    </EditPanelRow>
                </PanelBody>
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default translate()(RiskAssessment);
